import React from 'react';
import { BlogPost } from './types';
import { useDateTimeFormatter } from '../../../features/src/i18n';
import Link from 'next/link';
import { ImageAspectBox16x9 } from '../ui';
import { ContentfulImage } from '@spotify-internal/frodor-modules';
import {
  Text,
  black,
  cssSpacing,
  textClass,
} from '@spotify-internal/encore-web';
import styled from 'styled-components';

const Card = styled(Link)`
  margin-bottom: ${cssSpacing('looser-4')};
  &,
  * {
    text-decoration: none;
    color: ${black};
  }

  &:hover h2 {
    text-decoration: underline;
  }
`;

const TimeSection = styled.p`
  margin-bottom: ${cssSpacing('base')};
  margin-top: ${cssSpacing('base')};
`;

const Title = styled(Text).attrs({
  variant: 'titleLarge',
  forwardedAs: 'h2',
})`
  margin-bottom: ${cssSpacing('looser')};
`;

export const BlogPostPreview = ({ blogPost }: { blogPost: BlogPost }) => {
  const dateFormatter = useDateTimeFormatter();
  const releaseDateLocalized = dateFormatter.format(
    new Date(blogPost.releaseDate),
  );
  return (
    <Card href={`/blog/${blogPost.urlSlug}`}>
      <section>
        {blogPost.featuredAsset && (
          <ImageAspectBox16x9 ratio={9 / 16}>
            <ContentfulImage
              asset={blogPost.featuredAsset}
              placeholder={false}
            />
          </ImageAspectBox16x9>
        )}
        <TimeSection>
          <time
            className={textClass('bodySmall')}
            dateTime={blogPost.releaseDate}
          >
            {releaseDateLocalized}
          </time>
        </TimeSection>
        <Title>{blogPost.title}</Title>
        <Text as="p" variant="bodyMedium">
          {blogPost.description}
        </Text>
      </section>
    </Card>
  );
};
